<template>
  <div class="container examResult">
    <div class="floater"></div>
    <div class="exam_R_wrapper">
      <div class="R_userInfo">
        <h4>{{$store.state.userinfo.name}}</h4>
        <p>恭喜你完成全部答题内容！</p>
      </div>
      <div class="R_score">
        <div class="title"><i class="iconfont iconxingxing"></i>本次成绩结果<i class="iconfont iconxingxing"></i></div>
        <div class="R_score_item">
          <div class="R_score_list">
            <span class="label">答题总分：</span>
            <span class="val">{{examresult.examtotalscore}}</span>
          </div>
          <div class="R_score_list">
            <span class="label">本次成绩：</span>
            <span class="val redS">{{examresult.thistimescore}}</span>
          </div>
          <div class="R_score_list">
            <span class="label">最高成绩：</span>
            <span class="val">{{examresult.highestscore}}</span>
          </div>
          <div class="R_score_list">
            <span class="label">答题用时：</span>
            <span class="val S15">{{examresult.scoretimes}}秒</span>
          </div>
        </div>
      </div>
      <div class="R_footer">
        <button class="whiteBG" @click="$router.replace({path: '/exam'})">返回首页</button>
        <button class="redBG" @click="$router.replace({path: '/exam/ranking', query: {id: examresult.recordid}})">查看排行榜</button>
      </div>
    </div>
  </div>
</template>

<script>
  import API from '../../interface/api'
  export default {
    name: 'examResult',
    data () {
      return {
        examresult: {}
      }
    },
    created () {
      this.$toast.allowMultiple()
      const load = this.$toast({
        type: 'loading',
        duration: 0,
        loadingType: 'spinner',
        forbidClick: true,
        tipsMore: true
      })
      this.$fetch.get(API.EXAMRESULT, {
        examid: this.$route.query.id
      }).then(response => {
        // console.log(response)
        if (response.status !== 200) {
          var message = response.message ? response.message : '考试结果获取失败，请刷新！'
          this.$toast.fail(message)
          return
        }
        this.examresult = response.data
        load.clear()
      }).catch(err => {
        console.log(err)
        load.clear()
      })
    },
    mounted () {
    },
    methods: {
    },
    beforeRouteLeave (to, from, next) {
      this.$store.commit('deleteexam')
      next()
    }
  }
</script>

<style lang="stylus">
</style>